module.exports = __webpack_public_path__ + "img/new-validation-icon.3629d9bf.svg";